/** Summary cards for score, personas, and cadence — half of the row (8px gap between columns). */
export const PLAYBOOK_SUMMARY_HALF_WIDTH = "calc(50% - 4px)";
